import { useEffect } from "react";

export function useTheme(tg) {
  useEffect(() => {
    const apply = () => {
      const params = tg?.themeParams || {};
      document.documentElement.style.setProperty("--tg-theme-bg-color", params.bg_color || "#0b0b10");
      document.documentElement.style.setProperty("--tg-theme-text-color", params.text_color || "#f8fafc");
      document.documentElement.style.setProperty("--tg-theme-hint-color", params.hint_color || "#94a3b8");
      document.documentElement.style.setProperty("--tg-theme-button-color", params.button_color || "#7c3aed");
    };
    apply();
    tg?.onEvent?.("themeChanged", apply);
    return () => tg?.offEvent?.("themeChanged", apply);
  }, [tg]);
}
